<template>
  <b-card class="installation-tab">
    <select-installation-tab
      v-model="valueHandler"
      :customCompanies="companies"
      :customRegional="regional"
      :backup="value"
      :pagination="pagination"
      :selected-total="installationsHandler"
      :installations="installations"
      :loading-installations="loadingInstallations"
      :show-regional-when-empty="false"
      @page-changed="pageChanged"
      @get-oscilography-regional="getRegional"
      @update-selection="updateSelection"
      @search-installations="getInstallations"
    />
  </b-card>
</template>

<script>
import SelectInstallationTab from '@/domain/components/generalPanel/mySigma/selectInstallationsTab';
import OscillographyService from '@/domain/services/generalPanel/reports/oscillography';

export default {
  name: 'InstallationTab',
  components: {
    SelectInstallationTab,
  },
  props: {
    value: {
      type: Array,
    },
    backup: {
      type: Array,
    },
  },
  data: () => ({
    installations: [],
    companies: [],
    regional: [],
    loading: false,
    loadingInstallations: false,
    pagination: {
      currentPage: 1,
      perPage: 200,
      totalRows: null,
    },
  }),
  computed: {
    installationsHandler() {
      return this.installations.filter(({ selected }) => selected);
    },
    valueHandler: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  created() {
    this.getCompanies();
    this.getRegional();
    this.getInstallations();
  },
  methods: {
    getCompanies() {
      this.loading = true;
      OscillographyService
        .getCompanies()
        .then((response) => {
          this.companies = response;
          this.loading = false;
        });
    },
    getRegional(companiesIds) {
      this.loading = true;
      OscillographyService
        .getRegional({ companiesIds })
        .then((response) => {
          this.regional = response;
          this.loading = false;
        });
    },
    updateSelection(newSelection) {
      this.$emit('input', newSelection);
    },
    pageChanged(newPage) {
      this.pagination.currentPage = newPage;
      this.getInstallations();
    },
    getInstallations(filters) {
      const {
        perPage,
        currentPage,
      } = this.pagination;
      const payload = {
        filter: {
          ...filters,
        },
        pageSize: perPage,
        page: currentPage,
      };
      this.loadingInstallations = true;
      OscillographyService
        .getInstallations(payload)
        .then(({ data, total }) => {
          this.installations = data.map(installation => ({
            ...installation,
            selected: (this.backup || []).includes(installation.installationId),
          }));
          this.pagination.totalRows = total;
        })
        .finally(() => {
          this.loadingInstallations = false;
        });
    },
  },
};
</script>

<style lang="sass" scoped>
.installation-tab
  background-color: var(--color-background-regular)
</style>
